import request from '@/utils/request'

/**
 * 获取行驶报表
 * @param {*} data
 */
function getTripReport(data) {
  return request({
    url: '/report/trip/list',
    method: 'post',
    data
  })
}
/**
 * 导出
 * @param {*} data
 */
function exportTrip(data) {
    return request({
      url: '/report/trip/export',
      method: 'post',
      responseType: 'arraybuffer',
      data
    })
  }

export {
    getTripReport,
    exportTrip
  }
  